export const projects = [
  {
    name: 'Project 6',
    link: '/project-showcase/06',
    images: ['/assets/home/tile-1.png', '/assets/home/tile-glow-1.png'],
  },
  {
    name: 'Project 5',
    link: '/project-showcase/05',
    images: ['/assets/home/tile-5.png', '/assets/home/tile-glow-5.png'],
  },
  {
    name: 'Project 4',
    link: '/project-showcase/04',
    images: ['/assets/home/tile-4.png', '/assets/home/tile-glow-4.png'],
  },
  {
    name: 'Project 3',
    link: '/project-showcase/03',
    images: ['/assets/home/tile-3.png', '/assets/home/tile-glow-3.png'],
  },
  {
    name: 'DietCrm',
    link: '/project-showcase/02',
    images: ['/assets/home/tile-2.png', '/assets/home/tile-glow-2.png'],
  },
  {
    name: 'QualityTrack',
    link: '/project-showcase/01',
    images: ['/assets/home/tile-1.png', '/assets/home/tile-glow-1.png'],
  },
];

export const socials = [
  { name: 'Resume', link: '/' },
  {
    name: 'LinkedIn',
    link: 'https://www.linkedin.com/in/ishvendra-singh-82538a1b0/',
  },
  { name: 'Email', link: 'mailto:ishvendra@gmail.com' },
  { name: 'GitHub', link: 'https://github.com/Ishvendra' },
  { name: 'About', link: '/about' },
];

export const projectFooter = [
  { name: 'HOME', link: '/' },
  {
    name: 'ABOUT',
    link: '/about',
  },
];
